import * as React from 'react';
import * as Autosuggest from 'react-autosuggest';
import './LiveSearchInput.css';

interface ILiveSearchInputProps<T> {    
    placeholder: string
    renderSuggestion (suggestion: T): React.ReactNode;
    getSuggestionValue (suggestion: T): string;
    onFetchRequest (search: string, callback: (newSuggestions:T[]) => void ): void;
    onClear (): void
}

interface IState<T> {    
    suggestions: T[];
    value: string;
}

export default class LiveSearchInput<T> extends React.PureComponent<ILiveSearchInputProps<T>, IState<T>> {
    constructor(props: ILiveSearchInputProps<T>) {
        super(props);
        this.state = {
            suggestions: [],
            value: ''
        };
    }
   
    public render() {
        const { value, suggestions } = this.state;
        const inputProps = {
            onChange: this.onChange,
            placeholder: this.props.placeholder,
            value
        };

        return (
            <div >
                <Autosuggest
                    suggestions={suggestions}
                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                    onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                    getSuggestionValue={this.props.getSuggestionValue}                        
                    renderSuggestion={this.props.renderSuggestion}
                    inputProps={inputProps}
                />                    
            </div>
        );
    }

    private onChange = (e: React.ChangeEvent<HTMLInputElement>, { newValue, method }: Autosuggest.ChangeEvent) => {        
        this.setState({
            value: newValue
        }, () => {
            if( newValue.trim().length === 0 ){ this.props.onClear(); }
        });
    };

    private onSuggestionsFetchRequested = ({ value }: Autosuggest.SuggestionsFetchRequestedParams) => {
        this.props.onFetchRequest(
            value, ( newSuggestions ) => {
                this.setState({ suggestions: newSuggestions });
            }
        );        
    };

    private onSuggestionsClearRequested = () => {        
        this.setState({ suggestions: [] });
    };
}



// WEBPACK FOOTER //
// ./src/components/liveSearchInput/LiveSearchInput.tsx